
export enum ChaveConfiguracao {

  NON_DATABASE_VERSAO_API = 'NON_DATABASE_VERSAO_API',
  AMBIENTE = 'AMBIENTE',
  HL_HEALTHMAP = 'HL_HEALTHMAP',
  HL_HEALTHMAP_V3 = 'HL_HEALTHMAP_V3',
  OSRM = 'OSRM',
  COLETA = 'COLETA',
  GOOGLE = 'GOOGLE',
  GMAP = 'GMAP',
  EMAIL = 'EMAIL',
  CFG_INTEGRACAO = 'CFG_INTEGRACAO',
  ASSINATURA_EVAL = 'ASSINATURA_EVAL'

}
